import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { deleteCaseAttachmentQuery } from 'app/edozvola/cases/case-attachment/service/case-attachment.queries';
import { Loader } from 'app/shared/loader/loader';

export interface ICaseAttachmentDeleteModal {
  idCaseAttachment: number;
  isModalOpen: boolean;
  closeModalCallback: Function;
}

const CaseAttachmentDeleteModal = (props: ICaseAttachmentDeleteModal) => {
  const { mutate: deleteMutation, isPending } = deleteCaseAttachmentQuery(props.closeModalCallback);

  return (
    <Modal scrollable isOpen={props.isModalOpen} size={'lg'} toggle={() => props.closeModalCallback()} centered>
      {isPending && <Loader />}
      <ModalHeader>
        <span>Brisanje priloga</span>
      </ModalHeader>
      <ModalBody>
        <div>Jeste li sigurni da želite obrisati podatke?</div>
      </ModalBody>
      <ModalFooter>
        <Button size={'lg'} label="Odustani" outline onClick={() => props.closeModalCallback()} />
        <Button size={'lg'} label="Obriši" color={'danger'} onClick={() => deleteMutation(props.idCaseAttachment)} />
      </ModalFooter>
    </Modal>
  );
};

export default CaseAttachmentDeleteModal;
